"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventSourceTypes = void 0;
const list_source_hook_1 = require("../../utils/list-source-hook");
function useEventSourceTypes() {
    return (0, list_source_hook_1.useStaticListSource)([
        { id: 'USER', name: 'Uživatel' },
        { id: 'SYSTEM', name: 'Systém' },
        { id: 'EXTERNAL', name: 'Externí systém' },
    ]);
}
exports.useEventSourceTypes = useEventSourceTypes;
//# sourceMappingURL=alog-api.js.map